import React from "react";
import { Routes, Route } from "react-router-dom";

import WebsiteLayout from './layouts/WebsiteLayout';
import AuthLayout from './layouts/AuthLayout';
import AdminLayout from './layouts/AdminLayout';

import Home from './pages/Home';
import About from './pages/About';
import Chairman from './pages/Chairman';
import OrganizationStructure from './pages/OrganizationStructure'
import FunctionsAndPowers from './pages/FunctionsAndPowers';
import Constitution from './pages/Constitution';
import AdministrationAndFinance from './pages/AdministrationAndFinance';
import PocsoAct from './pages/PocsoAct';
import OtherActs from './pages/OtherActs';
import Acts from './pages/acts';
import Team from './pages/Team';
import Rti from './pages/rti';
import Commissions from './pages/commissions';
import AboutChildRights from './pages/AboutChildRights';
import RteAct from './pages/RteAct';
import Advisory from './pages/Advisory';
import PocsoDocuments from './pages/PocsoDocuments';
import Sop from './pages/Sop';
import JuvenileJustice from './pages/JuvenileJustice';
import EducationGuidelines from './pages/EducationGuidelines';
import OtherGuidelines from './pages/OtherGuidelines';
import AnnualReport from './pages/AnnualReport';
import NCPCRNews from './pages/NCPCRNews';
import BSCPCRRules from './pages/BSCPCRRules';
import BareActs from './pages/BareActs';
import RegisterComplaint from './pages/RegisterComplaint';


import GalleryVideos from './pages/GalleryVideos';
import Suggestion from './pages/Suggestion';
import Contact from './pages/Contact';
import Tender from './pages/Tender';

import Members from "./components/common/MembersCard";

import AdminLogin from './pages/auth/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import PrivateRoute from './components/auth/PrivateRoute';

import VideoListPage from "./pages/admin/VideoListPage";
import VideoCreatePage from "./pages/admin/VideoCreatePage";
import VideoEditPage from "./pages/admin/VideoEditPage";

import AdminComplaintsList from "./components/adiminComponents/AdminComplaintsList";
import AdminComplaintEdit from "./components/adiminComponents/AdminComplaintEdit";
import AdminComplaintView from "./components/adiminComponents/AdminComplaintView";

import TenderList from "./components/adiminComponents/TenderList";
import TenderForm from "./components/adiminComponents/TenderForm";

import CaseHearingPage from "./pages/admin/CaseHearingPage";

import AdminGalleryPage from "./pages/admin/AdminGalleryPage";
import CategoryList from "./pages/CategoryList";
import PhotoGallery from "./pages/PhotoGallery";
import ScrollToTop from "./components/common/ScrollToTop";




export default function AppRoutes() {
  return (
    <>
    <ScrollToTop />
    <Routes>
      {/* Public Website Routes */}
      <Route element={<WebsiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/AboutChildRights" element={<AboutChildRights />} />
        <Route path="/Chairman" element={<Chairman />} />
        <Route path="/OrganizationStructure" element={<OrganizationStructure />} />
        <Route path="/FunctionsAndPowers" element={<FunctionsAndPowers />} />
        <Route path="/Constitution" element={<Constitution />} />
        <Route path="/AdministrationAndFinance" element={<AdministrationAndFinance />} />
        <Route path="/acts" element={<Acts />} />
        <Route path="/team" element={<Team />} />
        <Route path="/commissions" element={<Commissions />} />
        <Route path="/OtherActs" element={<OtherActs />} />
        <Route path="/PocsoAct" element={<PocsoAct />} />
        <Route path="/BSCPCRRules" element={<BSCPCRRules />} />
       
        <Route path="/RteAct" element={<RteAct />} />
        <Route path="/PocsoDocuments" element={<PocsoDocuments />} />
        <Route path="/rti" element={<Rti />} />
        <Route path="/Advisory" element={<Advisory />} />
        <Route path="/Sop" element={<Sop />} />
        <Route path="/JuvenileJustice" element={<JuvenileJustice />} />
        <Route path="/EducationGuidelines" element={<EducationGuidelines />} />
        <Route path="/OtherGuidelines" element={<OtherGuidelines />} />
        <Route path="/AnnualReport" element={<AnnualReport />} />
        <Route path="/NCPCRNews" element={<NCPCRNews />} />
        <Route path="/BareActs" element={<BareActs />} />
        <Route path="/RegisterComplaint" element={<RegisterComplaint />} />  

        <Route path="/category" element={<CategoryList />} />
        <Route path="/gallery/:id" element={<PhotoGallery />} />  

        <Route path="/videos" element={<GalleryVideos />} />
        <Route path="/suggestion" element={<Suggestion />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tender" element={<Tender />} />     
        <Route path="/Members" element={<Members />} />


      </Route>

       {/* Auth layout */}
      <Route element={<AuthLayout />}>
        <Route path="/admin/login" element={<AdminLogin />} />
      </Route>

         {/* Admin layout with PrivateRoute */}
      <Route
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      >
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/videos" element={<VideoListPage />} />
        <Route path="/admin/videos/create" element={<VideoCreatePage />} />
        <Route path="/admin/videos/:id/edit" element={<VideoEditPage />} /> 
        <Route path="/admin/complaints" element={<AdminComplaintsList />} />
        <Route path="/admin/complaints/edit/:id" element={<AdminComplaintEdit />} />
        <Route path="/admin/complaints/view/:id" element={<AdminComplaintView />} />
        
        <Route path="/admin/tenders" element={<TenderList />} />
        <Route path="/admin/tender/create" element={<TenderForm />} />
        <Route path="/admin/tender/edit/:id" element={<TenderForm />} />
        <Route path="/admin/case-hearing" element={<CaseHearingPage />} />
        <Route path="/admin/gallery" element={<AdminGalleryPage />} />

              
        {/* Add more admin pages here */}
      </Route>
      
    </Routes>
    </>
  );
}
